import React from 'react';
import { DONE_FLAGS } from './ResponseQuestionRow';

const Bar = ({ label, done, total }) => (
  <div className="flex items-center gap-2 text-[10px]">
    <span className="w-36 truncate text-slate-600">{label}</span>
    <div className="flex-1 h-2.5 bg-slate-100 rounded-full overflow-hidden">
      <div className={`h-full rounded-full ${done === total ? 'bg-emerald-500' : 'bg-[#4ABFCF]'}`}
        style={{ width: `${Math.max(3, (done / Math.max(total, 1)) * 100)}%` }} />
    </div>
    <span className="w-14 text-right text-slate-500">{done}/{total}</span>
  </div>
);

export const ResponseProgress = ({ questions }) => {
  const byCat = {}, byResp = {};
  for (const q of questions) {
    const cat = q.match?.category_names?.[0] || 'Unmatched';
    const resp = q.assigned_to || 'Unassigned';
    const done = DONE_FLAGS.includes(q.flag) ? 1 : 0;
    byCat[cat] = { done: (byCat[cat]?.done || 0) + done, total: (byCat[cat]?.total || 0) + 1 };
    byResp[resp] = { done: (byResp[resp]?.done || 0) + done, total: (byResp[resp]?.total || 0) + 1 };
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1.5 bg-slate-50 border border-slate-100 rounded-md p-3" data-testid="rfp-resp-progress">
      <div className="space-y-1.5">
        <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide">Progress by category</p>
        {Object.entries(byCat).map(([c, r]) => <Bar key={c} label={c} done={r.done} total={r.total} />)}
      </div>
      <div className="space-y-1.5" data-testid="rfp-resp-progress-responders">
        <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide">Progress by responder</p>
        {Object.entries(byResp).map(([e, r]) => <Bar key={e} label={e} done={r.done} total={r.total} />)}
      </div>
    </div>
  );
};
